<template>
  <div class="lee-platform-container">
    <el-tabs v-model="active">
      <el-tab-pane label="抖音" name="douyin">
        <lee-tiktok />
      </el-tab-pane>
      <el-tab-pane label="快手" name="kuaishou">
        <lee-kuaishou />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import LeeTiktok from "./tiktok.vue";
import LeeKuaishou from "./kuaishou.vue";
export default {
  components: {
    LeeTiktok,
    LeeKuaishou,
  },
  data() {
    return {
      active: "douyin",
    };
  },
};
</script>
<style lang="less" scoped>
.lee-platform-container {
  background: #fff;
  padding: 20px 33px;
}
</style>
